const initializeActiveSwatches = () => {
  const productCards = document.querySelectorAll('.product-card-wrapper');
  productCards.forEach((productCard) => {
    const productHandle = productCard.getAttribute('data-product-handle');
    const swatches = productCard.querySelectorAll('.swatch');

    swatches.forEach((swatch) => {
      const swatchHandle = swatch.getAttribute('handle');
      if (swatchHandle === productHandle) {
        swatch.classList.add('active');
      } else {
        swatch.classList.remove('active');
      }
    });
  });
};

const initializeCollectionSwatches = (selector) => {
  initializeActiveSwatches();

  const swatchesBtn = document.querySelectorAll(`${selector ? selector : ''} .product-card-wrapper .swatch`);
  swatchesBtn.forEach((sBtn) => {
    sBtn.addEventListener('click', (e) => {
      if(e.target.closest('.swatch').classList.contains('active')) {
        return;
      }

      e.preventDefault();

      const productCard = e.target.closest(".product-card-wrapper");
      const swatches = productCard.querySelectorAll('.swatch');
      swatches.forEach((swatch) => {
        swatch.classList.remove('active');
        e.target.closest('.swatch').classList.add('active');
      });

      const mainImage = productCard.querySelector('.card__media #main-product-image');
      const hoverImage = productCard.querySelector('.card__media #secondary-image');
      const mainImageTitleElement = productCard.querySelectorAll('.card__content h3.card__heading a');
      const mainImagePriceElement = productCard.querySelector('.price__container span.price-item');

      const mainMediaUrl = productCard.querySelector('.card__media a').getAttribute('href');
      const newMediaUrl = e.target.getAttribute('media-url');
      const newSrc = e.target.getAttribute("data-src");
      const newSrcSet = e.target.getAttribute("data-srcset");
      const newSrcHover = e.target.getAttribute("data-src-hover");
      const newSrcSetHover = e.target.getAttribute("data-srcset-hover");
      const newTitle = e.target.getAttribute('product-title');
      const newPrice = e.target.getAttribute('product-price');

      if (mainImage) {
        mainImage.src = newSrc;
        mainImage.srcset = newSrcSet;
        hoverImage.srcset = newSrcSetHover;
        hoverImage.src = newSrcHover;
      }

      if (mainImageTitleElement && newTitle) {
        mainImageTitleElement.forEach((itemTitle) => {
          itemTitle.textContent = newTitle;
        });
      }

      if (mainImagePriceElement && newPrice) {
        mainImagePriceElement.innerHTML = newPrice;
      }

      if (mainMediaUrl && newMediaUrl) {
        const mediaLink = productCard.querySelector('.card__media a');
        const headingLink = productCard.querySelectorAll('.card__content .card__information a');

        if (mediaLink) {
          mediaLink.setAttribute('href', newMediaUrl);
        }

        if (headingLink) {
          headingLink.forEach((itemLink) => {
            itemLink.setAttribute('href', newMediaUrl);
          });
        }
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", initializeCollectionSwatches(undefined));
